/**
 * FreelancerPortal.jsx — /freelancer
 * Freelancer AI Toolkit — paid (ai_tools tier)
 *
 * Tools:
 *   Upwork Proposal Generator
 *   Email Generator
 *   LinkedIn Outreach (LinkedIn Post Generator)
 *   Recruiter Reply
 *   Prompt Generator
 *   Invoice Generator    (free version — no account needed)
 *   Freelance Rate Calculator (free version — no account needed)
 */
import React from 'react';
import PortalLayout from './PortalLayout';

// AI tools (gated)
import { UpworkProposalGenerator }  from '../NewAITools';
import { EmailGenerator, LinkedInGenerator }           from '../AITools';
import { LinkedInPostGenerator }    from '../AITools';
import { RecruiterReplyGenerator }  from '../NewAITools';
import { PromptGenerator }          from '../AITools';

// Free tools (always accessible — no gate needed)
import { InvoiceGenerator }  from '../BusinessTools';
import { FreelanceRateCalc} from '../BusinessTools';

const TOOLS = [
  {
    id:        'upwork_proposal',
    label:     'Upwork Proposal',
    icon:      '🏆',
    desc:      'Win more contracts',
    component: UpworkProposalGenerator,
    badge:     'Top tool',
    ai:        true,
  },
  {
    id:        'email_gen',
    label:     'Email Generator',
    icon:      '📧',
    desc:      'Cold outreach & follow-ups',
    component: EmailGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'linkedin_outreach',
    label:     'LinkedIn Outreach',
    icon:      '💼',
    desc:      'Posts & connection messages',
    component: LinkedInGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'recruiter_reply',
    label:     'Recruiter Reply',
    icon:      '🤝',
    desc:      'Reply to inbound recruiters',
    component: RecruiterReplyGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'prompt_gen',
    label:     'Prompt Generator',
    icon:      '✨',
    desc:      'Write better AI prompts',
    component: PromptGenerator,
    badge:     null,
    ai:        true,
  },
  {
    id:        'invoice_gen',
    label:     'Invoice Generator',
    icon:      '🧾',
    desc:      'Free — no sign-up needed',
    component: InvoiceGenerator,
    badge:     'Free',
    ai:        false,
  },
  {
    id:        'rate_calc',
    label:     'Freelance Rate',
    icon:      '💰',
    desc:      'Calculate your hourly rate',
    component: FreelanceRateCalc,
    badge:     'Free',
    ai:        false,
  },
];

const OTHER_PORTALS = [
  { label: '🎯 Job Search', path: '/job-search' },
  { label: '⌨️ Developer',  path: '/developer'  },
  { label: '🛠️ Free Tools', path: '/tools'      },
  { label: '🍁 Finance',    path: '/finance'    },
];

export default function FreelancerPortal() {
  return (
    <PortalLayout
      title="Freelancer AI Toolkit"
      icon="💼"
      color="#b78cff"
      tagline="Write winning proposals · Send outreach emails · Calculate your rate · Generate invoices"
      tools={TOOLS}
      otherPortals={OTHER_PORTALS}
      upgradeDesc="Get Upwork proposals, email outreach, LinkedIn posts and more with a 7-day free trial. Invoice Generator and Rate Calculator are always free."
    />
  );
}
